import React, { useState } from "react";
import ContactsIcon from "../../assets/icons/contact_edit.svg2";
import BillingLinks from "./BillingLinks";
import InvoicingIcon from "../../assets/icons/invoicing.svg2";
import PageHeader from "../Common/PageHeader";
import WhiteButton from "../Common/WhiteButton";
import BoomerangUiSalesIcon from "../../assets/icons/boomerang_element-01.svg2";
import SwitchAccountIcon from "../../assets/icons/switch_refresh.svg2";
import Subheading from "../Common/Subheading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { Col, FloatingLabel, Form, Row } from "react-bootstrap";
import HelpButton from "../HelpContent/HelpButton";
import MyIcon from "../Common/MyIcon";
import BillingDetailsIcon from "../../assets/icons/invoice_history.svg2";
import BillingIcon from "../../assets/icons/icon_reporting_financials_white-01.svg2";
import MyCollapse from "../Common/MyCollapse";
import { settings } from "survey-core";
import NewFeature from "../Builder/Components/NewFeature";
import WhiteButtonDropdown from "../Common/WhiteButtonDropdown";

export default function BillingDetails() {
  const [billingSettings, setBillingSettings] = useState({
    paymentTerms: "28",
    companyName: "",
    registrationNumber: "0",
    vatNumber: "0",
    address: "",
  });
  const [accountsContact, setAccountsContact] = useState({
    name: "",
    email: "",
  });

  const handleBillingChange = (e) =>
    setBillingSettings((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  const handleAccountChange = (e) =>
    setAccountsContact((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  return (
    <div>
      <NewFeature>
        <div className="d-flex justify-content-between align-items-start">
          <Subheading
            Icon={InvoicingIcon}
            heading="Billing Details"
            subheading="The billing information for your account"
          />

          <div>
            <WhiteButtonDropdown toggleHeading={"Actions"} toggleSubheading={"Billing Details"}>
              <WhiteButton
                as="RRLink"
                icon={ContactsIcon}
                heading="Switch Account"
              />

              <WhiteButton
                as="RRLink"
                icon={BoomerangUiSalesIcon}
                heading="Boomerang UI Sales"
              />
            </WhiteButtonDropdown>
          </div>
        </div>
        <div className="mb-5 my-3">
          <Form>
            <Row xs={1} xl={2}>
              <Col>
                <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 ">
                  <MyCollapse
                    heading={
                      <>
                        <h5 className=" d-flex align-items-center">
                          <MyIcon Icon={BillingDetailsIcon} className="me-2" />
                          <span className="ms-2">
                            <span className="fw-bold me-2">
                              {" "}
                              Billing details:
                            </span>
                            <HelpButton helpKey="settings-billing-details" />
                            <div className="small text-secondary">
                              Manage billing details
                            </div>
                          </span>
                        </h5>
                      </>
                    }
                  >
                    <hr className="my-3 text-secondary" />
                    <div className="row">
                      <div className="col-6">
                        <FloatingLabel label="Payment Terms:" className="mb-2">
                          <Form.Control
                            name="paymentTerms"
                            placeholder="Payment Terms"
                            onChange={handleBillingChange}
                            value={billingSettings.paymentTerms}
                          />
                        </FloatingLabel>
                      </div>
                      <div className="col-6">
                        <FloatingLabel label="Company Name:" className="mb-2">
                          <Form.Control
                            name="companyName"
                            placeholder="Company Name"
                            onChange={handleBillingChange}
                            value={billingSettings.companyName}
                          />
                        </FloatingLabel>
                      </div>
                      <div className="col-6">
                        <FloatingLabel
                          label="Registration Number:"
                          className="mb-2"
                        >
                          <Form.Control
                            type="number"
                            onChange={handleBillingChange}
                            name="registrationNumber"
                            placeholder="Registration Number"
                            value={billingSettings.registrationNumber}
                          />
                        </FloatingLabel>
                      </div>
                      <div className="col-6">
                        <FloatingLabel label="VAT Number:" className="mb-2">
                          <Form.Control
                            type="number"
                            onChange={handleBillingChange}
                            placeholder="VAT Number"
                            name="vatNumber"
                            value={billingSettings.vatNumber}
                          />
                        </FloatingLabel>
                      </div>
                      <div className="col-6">
                        <FloatingLabel
                          label="Billing Address (including postcode):"
                          className="mb-2"
                        >
                          <Form.Control
                            as="textarea"
                            name="address"
                            placeholder="Billing Address"
                            onChange={handleBillingChange}
                            value={billingSettings.address}
                          />
                        </FloatingLabel>
                      </div>
                    </div>
                  </MyCollapse>
                </div>
              </Col>
              <Col>
                <div className="bg-purple-gradient-darker-reverse rounded-4 p-3">
                  <MyCollapse
                    heading={
                      <>
                        <h5 className=" d-flex align-items-center">
                          <span className="ms-2">
                            <span className="fw-bold me-2">
                              Accounts contact
                            </span>
                            <HelpButton helpKey="settings-accounts-contacts" />
                            <div className="small text-secondary">
                              contact used for communications related to
                              subscription's billing, e.g., invoices
                            </div>
                          </span>
                        </h5>
                      </>
                    }
                  >
                    <hr className="my-3 text-secondary" />
                    <div className="row">
                      <div className="col-6">
                        <FloatingLabel label="Name:" className="mb-2">
                          <Form.Control
                            name="name"
                            placeholder="Name"
                            onChange={handleAccountChange}
                            value={accountsContact.name}
                          />
                        </FloatingLabel>
                      </div>
                      <div className="col-6">
                        <FloatingLabel label="Email:" className="mb-2">
                          <Form.Control
                            placeholder="Email"
                            type="email"
                            name="email"
                            onChange={handleAccountChange}
                            value={accountsContact.email}
                          />
                        </FloatingLabel>
                      </div>
                    </div>
                  </MyCollapse>
                </div>
              </Col>
            </Row>
            <hr className="my-5 text-secondary" />
            <div className="d-flex justify-content-end">
              <button
                type="submit"
                className="btn btn-colored-reverse rounded-pill fw-bold "
              >
                <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                SAVE SETTINGS{" "}
              </button>
            </div>
          </Form>
        </div>
      </NewFeature>
    </div>
  );
}
